<div role="main">
	<div class="container page-contents">
		<div class="row align-items-center">
			<div class="col">
				<h2 class="page-title m-0 py-3" i18n="requests page/menu title">Transfer Requests</h2>
			</div>

			<div class="col-sm-auto" *ngIf="allowedTransfer">
				<button mat-flat-button type="button" i18n (click)="searchUser()" id="searchUserBtn"> Search user </button>
			</div>

			<div class="col-sm-auto" *ngIf="allowedTransfer">
				<button mat-flat-button type="button" i18n (click)="createRequest()" id="newRequestBtn"> New Transfer Request </button>
			</div>
		</div>

		<div class="row">
			<div class="col"><hr class="mt-0"/></div>
		</div>

		<div class="row justify-content-center">
			<ng-container *ngIf="!allowedTransfer">
				<div class="text-danger my-4" i18n>Hey there, thanks for signing up. To begin, please verify your email address. We have sent you an email containing a validation link. Click the link, and you're all set!</div>
			</ng-container>

			<mat-tab-group
				class="col-12"
				dynamicHeight
				animationDuration="0ms"
				mat-stretch-tabs
				[selectedIndex]="selectedTab"
				(selectedIndexChange)="selectTab($event)"
			>
				<mat-tab label="My Open Transfer Requests">
					<ng-template matTabContent>
						<app-registrations-list *ngIf="myRequests.length > 0" [list]="myRequests"></app-registrations-list>
					</ng-template>
				</mat-tab>
				<mat-tab label="All Open Transfer Requests">
					<ng-template matTabContent>
						<app-registrations-list *ngIf="allRequests.length > 0" [list]="allRequests"></app-registrations-list>
					</ng-template>
				</mat-tab>
				<mat-tab label="Transfer Requests between dates">
					<ng-template matTabContent>
						<div class="container-fluid justify-content-center row pt-4 filters">
							<form [formGroup]="searchForm" id="search-form" class="col-xl-9">
								<div class="row ml-4">
									<mat-form-field appearance="standard" class="date-picker" floatLabel="always" (click)="fromDate.open()">
										<mat-label i18n>After</mat-label>
										<input matInput [matDatepicker]="fromDate" formControlName="ctrFrom" [max]="searchForm.controls.ctrTo.value ? searchForm.controls.ctrTo.value : null">
										<mat-datepicker-toggle class="d-inline-block" matSuffix [for]="fromDate"></mat-datepicker-toggle>
										<mat-datepicker-toggle class="d-inline-block" matSuffix *ngIf="searchForm.controls.ctrFrom.value" (click)="clearFilter($event, 'ctrFrom')">
											<mat-icon matDatepickerToggleIcon>delete</mat-icon>
										</mat-datepicker-toggle>
										<mat-datepicker disabled="false" #fromDate></mat-datepicker>
									</mat-form-field>
									<span class="ml-1 mr-1 mt-4">-</span>
									<mat-form-field appearance="standard" class="date-picker" floatLabel="always" (click)="toDate.open()">
										<mat-label i18n>Before</mat-label>
										<input matInput [matDatepicker]="toDate" formControlName="ctrTo" [min]="searchForm.controls.ctrFrom.value ? searchForm.controls.ctrFrom.value : null">
										<mat-datepicker-toggle class="d-inline-block" matSuffix [for]="toDate"></mat-datepicker-toggle>
										<mat-datepicker-toggle class="d-inline-block" matSuffix *ngIf="searchForm.controls.ctrTo.value" (click)="clearFilter($event, 'ctrTo')">
											<mat-icon matDatepickerToggleIcon>delete</mat-icon>
										</mat-datepicker-toggle>
										<mat-datepicker disabled="false" #toDate></mat-datepicker>
									</mat-form-field>
								</div>

								<div class="row ml-4">
									<mat-form-field appearance="standard" floatLabel="always">
										<mat-label i18n>Status</mat-label>
										<mat-select formControlName="ctrStatus">
											<mat-option *ngFor="let status of statuses" [value]="status.id">{{status.label}}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

								<div class="row ml-4">
									<mat-form-field appearance="standard" floatLabel="always">
										<mat-label i18n>Admin user (Id)</mat-label>
										<input matInput type="string" placeholder="" formControlName="ctrUser" />
										<button type="button" matSuffix class="btn btn-outline-dark btn-sm" (click)="me()" i18n>Me</button>
									</mat-form-field>
								</div>

								<div class="row mr-4">
									<div class="col-12 text-right mb-4 mt-2">
										<button
											[disabled]="searchForm.invalid"
											type="submit"
											mat-flat-button
											color="primary"
											i18n
											(click)="submitRequestsHistory()"
											class="col-12 col-sm-auto mr-sm-2"
										>Search</button>

										<button
											type="button"
											mat-flat-button
											color="warn"
											i18n
											(click)="clearFilter($event)"
											title="Reset search form."
											i18n-title
											class="col-12 col-sm-auto mb-2 mb-sm-0 reset-button"
										>Reset</button>
									</div>
								</div>
							</form>
						</div>

						<div class="row">
							<div class="col-12">
								<app-registrations-list *ngIf="datedRequests.length > 0" [list]="datedRequests"></app-registrations-list>
							</div>
						</div>
					</ng-template>
				</mat-tab>
			</mat-tab-group>
		</div>
	</div>
</div>
